import React from 'react'

const SkillLevelElement = ({text}) => {
    return (
        <>
            <div className='skillsContenerLevelsElement'>
                Poziom {text}
            </div>
        </>
    );
};

export default SkillLevelElement
